import { render, staticRenderFns } from "./SignUpDetail.vue?vue&type=template&id=637edae3&"
import script from "./SignUpDetail.vue?vue&type=script&lang=js&"
export * from "./SignUpDetail.vue?vue&type=script&lang=js&"
import style0 from "./SignUpDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports